module.exports = __webpack_public_path__ + "67001d2a8840b34f8407526c30a399d5.svg";